export type UnchangedUpdateResponse = {
    unchanged: true;
    message?: string;
};

export function isUnchangedUpdateResponse(value: unknown): value is UnchangedUpdateResponse {
    return (
        typeof value === "object" &&
        value !== null &&
        (value as UnchangedUpdateResponse).unchanged === true
    );
}

export function assertEntityUpdateResult<T>(value: T | UnchangedUpdateResponse): T {
    if (isUnchangedUpdateResponse(value)) {
        throw new Error(value.message ?? "Update returned unchanged response.");
    }
    return value;
}
